import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const AllocatedRoutes = memo((props) => {
  return (
    <SvgIcon viewBox="0 0 32 32" fill="none" {...props}>
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <path d="M0 0H32V32H0V0Z" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0)">
        <mask
          id="mask1"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="12"
          width="12"
          height="12"
        >
          <rect y="12" width="12" height="12" fill="#C4C4C4" />
        </mask>
        <g mask="url(#mask1)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 17.995L1.025 17.045C2.19219 17.5998 3.30104 18.2698 4.335 19.045C6.40565 16.5481 8.88398 14.4197 11.665 12.75L12 13.52C9.43 15.76 7.55 18.26 4.84 23.12C3.34792 21.3011 1.73065 19.5886 0 17.995Z"
            fill={props.fill ? props.fill : "white"}
          />
        </g>
        <path
          d="M27.2068 4H8V8.79323H27.2068V4ZM32 13.6034H14.2219V18.3966H32V13.6034ZM24.8017 23.1898H8V28H24.8017V23.1898Z"
          fill={props.fill ? props.fill : "white"}
        />
      </g>
    </SvgIcon>
  );
});
